/* eslint-disable react/jsx-wrap-multilines */
import React from "react";

import * as Styled from "./styles";

interface Props {
  title: string;
  checked: boolean;
  module: "CONTRACT" | "CONCRETING" | "INVOICE" | "CERTIFICATE" | "CONCRETING_REQUEST" | "CLIENT" | "AMOUNTS";
  handleChangeCheckbox: (checked: boolean, module: string) => void;
}

const ModuleCheckbox: React.FC<Props> = ({
  title,
  checked,
  module,
  handleChangeCheckbox
}) => (
  <Styled.Container>
    <Styled.CustomFormControlLabel
      control={
        <Styled.CustomCheckbox
          checked={checked}
          onChange={(_, checked) => handleChangeCheckbox(checked, module)}
        />
        }
      label={title}
    />
  </Styled.Container>
);

export default ModuleCheckbox;
